/* MACONDO – small mobile helpers (only act under 750px). */
(function () {
  var mq = window.matchMedia('(max-width: 749px)');
  var main = document.querySelector('main');
  var tpl = (main && main.dataset.template) || '';

  function headerHeight() {
    var h = document.querySelector('header-component, #header-component, .header');
    return h ? Math.round(h.getBoundingClientRect().height) : 60;
  }

  /* ---------- Sticky add to cart (product page) ---------- */
  function initStickyATC() {
    if (tpl.indexOf('product') !== 0) return;
    var btn = document.querySelector('main product-form-component button[name="add"]') ||
      document.querySelector('main button[name="add"]');
    if (!btn) return;

    var bar = document.createElement('div');
    bar.className = 'm-atc';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML =
      '<div class="m-atc__info"><span class="m-atc__title"></span><span class="m-atc__meta"></span></div>' +
      '<button type="button" class="m-atc__btn" tabindex="-1"></button>';
    document.body.appendChild(bar);

    var titleEl = bar.querySelector('.m-atc__title');
    var metaEl = bar.querySelector('.m-atc__meta');
    var b = bar.querySelector('.m-atc__btn');
    var og = document.querySelector('meta[property="og:title"]');
    titleEl.textContent = (og ? og.content : document.title).split('|')[0].trim();

    function sync() {
      var raw = (btn.innerText || '').replace(/\s+/g, ' ');
      b.textContent = /sold out/i.test(raw) ? 'Sold out' : /unavailable/i.test(raw) ? 'Unavailable' : 'Add to cart';
      b.disabled = btn.disabled || btn.getAttribute('aria-disabled') === 'true';
      var priceEl = document.querySelector('main product-price .price, main product-price');
      var price = '';
      if (priceEl) {
        var lines = priceEl.innerText.split('\n');
        for (var i = 0; i < lines.length; i++) {
          if (/\d/.test(lines[i])) { price = lines[i].trim(); break; }
        }
      }
      var sel = document.querySelector('main variant-picker input[type="radio"]:checked');
      var size = sel ? sel.value : '';
      metaEl.textContent = [size ? 'Size ' + size : '', price].filter(Boolean).join(' · ');
    }

    b.addEventListener('click', function () {
      btn.click();
    });

    var visible = false;
    function setVisible(v) {
      visible = v && mq.matches;
      bar.classList.toggle('is-visible', visible);
      document.body.classList.toggle('m-atc-on', visible);
    }

    /* show the bar only once the real button has been scrolled past (above the screen) */
    var ticking = false;
    function check() {
      ticking = false;
      setVisible(btn.getBoundingClientRect().bottom < 0);
    }
    function onScroll() {
      if (!ticking) { ticking = true; requestAnimationFrame(check); }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    check();

    /* keep the bar above anything fixed at the bottom (e.g. the Shopify theme-preview bar) */
    function placeBar() {
      var pb = document.getElementById('PBarNextFrameWrapper');
      var h = 0;
      if (pb && getComputedStyle(pb).display !== 'none') {
        var r = pb.getBoundingClientRect();
        if (r.height && r.bottom >= window.innerHeight - 2) h = Math.round(r.height);
      }
      bar.style.setProperty('--m-atc-offset', h + 'px');
    }
    placeBar();
    setTimeout(placeBar, 1500);
    setTimeout(placeBar, 4000);
    window.addEventListener('resize', placeBar);

    new MutationObserver(sync).observe(btn, { attributes: true, childList: true, subtree: true, characterData: true });
    document.addEventListener('change', function (e) {
      if (e.target.closest && e.target.closest('variant-picker')) setTimeout(sync, 60);
    });
    document.addEventListener('variant:update', function () { setTimeout(sync, 60); });
    sync();
    setTimeout(sync, 800);
  }

  /* ---------- Brand list: A–Z index ---------- */
  function initAZ() {
    if (tpl !== 'page.brand') return;
    var sec = document.querySelector('.tabs-group-section');
    if (!sec) return;
    var tabs = sec.querySelector('.tabs');
    if (!tabs) return;
    var nav = document.createElement('nav');
    nav.className = 'm-az';
    nav.setAttribute('aria-label', 'Brands A–Z');
    tabs.appendChild(nav);

    function build() {
      var panel = sec.querySelector('.tab-panel:not([hidden])');
      nav.innerHTML = '';
      if (!panel) return;
      var seen = {};
      panel.querySelectorAll('strong').forEach(function (s) {
        var L = (s.textContent || '').trim().charAt(0).toUpperCase();
        if (!/[A-Z0-9]/.test(L) || seen[L]) return;
        seen[L] = true;
        if (!s.id) s.id = 'az-' + panel.id + '-' + L;
        var a = document.createElement('a');
        a.href = '#' + s.id;
        a.textContent = L;
        a.addEventListener('click', function (e) {
          e.preventDefault();
          var offset = headerHeight() + tabs.getBoundingClientRect().height + 8;
          window.scrollTo({ top: s.getBoundingClientRect().top + window.scrollY - offset, behavior: 'smooth' });
        });
        nav.appendChild(a);
      });
    }

    build();
    sec.querySelectorAll('.tab-button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        setTimeout(function () {
          build();
          if (!mq.matches) return;
          var top = sec.getBoundingClientRect().top + window.scrollY - headerHeight();
          if (window.scrollY > top) window.scrollTo({ top: top });
        }, 0);
      });
    });
  }

  /* ---------- Swipe for the homepage slideshow ---------- */
  function initSwipe() {
    document.querySelectorAll('[class^="ai-slideshow-"]').forEach(function (el) {
      if (el.tagName.indexOf('SLIDESHOW-BANNER') !== 0 || el.dataset.mSwipe) return;
      el.dataset.mSwipe = '1';
      var x0 = null, y0 = null;
      el.addEventListener('touchstart', function (e) {
        x0 = e.touches[0].clientX; y0 = e.touches[0].clientY;
      }, { passive: true });
      el.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
        x0 = null;
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
        if (dx < 0 && el.goToNextSlide) el.goToNextSlide();
        if (dx > 0 && el.goToPrevSlide) el.goToPrevSlide();
        if (el.resetAutoplay) el.resetAutoplay();
      }, { passive: true });
    });
  }

  /* ---------- Store page: intro text collapsed with "Read more" ---------- */
  function initStoreIntro() {
    if (tpl !== 'page.macondo-store') return;
    var sec = main.children[1];
    if (!sec) return;
    var blocks = sec.querySelectorAll('.text-block');
    var tb = null;
    for (var i = 0; i < blocks.length; i++) {
      if (blocks[i].querySelectorAll('p').length > 1) { tb = blocks[i]; break; }
    }
    if (!tb) return;
    tb.classList.add('m-clamp');
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'm-more';
    b.textContent = 'Read more';
    b.setAttribute('aria-expanded', 'false');
    tb.parentNode.insertBefore(b, tb.nextSibling);
    b.addEventListener('click', function () {
      var open = tb.classList.toggle('is-open');
      b.textContent = open ? 'Read less' : 'Read more';
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* ---------- Product page: info in tabs (Description / Details / Shipping) ---------- */
  function initProductInfo() {
    if (tpl.indexOf('product') !== 0) return;
    var bb = document.querySelector('main .buy-buttons-block');
    if (!bb) return;
    var col = bb.parentElement;
    var kids = Array.prototype.slice.call(col.children);

    /* "Size chart" on the right of the price row (phones only; on desktop it stays under the sizes) */
    var sg = col.querySelector(':scope > .macondo-size-guide-wrap');
    var price = col.querySelector('product-price');
    if (false && sg && price && price.parentElement) { /* size chart stays under the sizes on every screen */
      var row = price.parentElement;
      if (getComputedStyle(row).position === 'static') row.style.position = 'relative';
      row.appendChild(sg);
      sg.classList.add('m-sg-inline');
      var place = function () { sg.style.top = price.offsetTop + 'px'; };
      place();
      setTimeout(place, 600);
      window.addEventListener('resize', place);
    }

    var desc = null, details = [], acc = null;
    var start = kids.indexOf(bb);
    for (var i = start + 1; i < kids.length; i++) {
      var k = kids[i];
      if (k.classList.contains('accordion')) { acc = acc || k; continue; }
      if (k.tagName === 'RTE-FORMATTER') { details.push(k); continue; }
      if (!desc && k.querySelector(':scope > .rte')) { desc = k; }
    }
    if (!desc && !details.length && !acc) return;

    var tabs = [];
    if (desc) tabs.push(['Description', [desc]]);
    if (details.length) tabs.push(['Details', details]);
    if (acc) tabs.push(['Shipping & returns', [acc]]);

    var box = document.createElement('div');
    box.className = 'm-ptabs';
    var nav = document.createElement('div');
    nav.className = 'm-ptabs__nav';
    nav.setAttribute('role', 'tablist');
    box.appendChild(nav);
    var first = desc || details[0] || acc;
    col.insertBefore(box, first);

    var buttons = [], panels = [];
    tabs.forEach(function (t, n) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.setAttribute('role', 'tab');
      btn.textContent = t[0];
      var panel = document.createElement('div');
      panel.className = 'm-ptabs__panel';
      panel.setAttribute('role', 'tabpanel');
      t[1].forEach(function (el) { panel.appendChild(el); });
      nav.appendChild(btn);
      box.appendChild(panel);
      buttons.push(btn);
      panels.push(panel);
      /* react on press (not only on release) so the first click always switches tab */
      btn.addEventListener('pointerdown', function (e) { if (e.button === 0) select(n); });
      btn.addEventListener('click', function () { select(n); });
    });
    function select(n) {
      buttons.forEach(function (b, j) {
        b.classList.toggle('is-active', j === n);
        b.setAttribute('aria-selected', j === n ? 'true' : 'false');
        panels[j].hidden = j !== n;
      });
    }
    select(0);

    /* bold labels in Details ("Composition:", "SKU:", "Made in:") */
    details.forEach(function (d) {
      var p = d.querySelector('p') || d;
      var t = p.firstChild;
      if (t && t.nodeType === 3 && t.nodeValue.indexOf(':') > 0) {
        var idx = t.nodeValue.indexOf(':') + 1;
        var strong = document.createElement('strong');
        strong.textContent = t.nodeValue.slice(0, idx);
        t.nodeValue = t.nodeValue.slice(idx);
        p.insertBefore(strong, t);
      }
    });

    /* shipping/returns: show the texts directly */
    if (acc) {
      acc.querySelectorAll('details').forEach(function (d) {
        d.open = true;
        var s = d.querySelector('summary');
        if (s) s.addEventListener('click', function (e) { e.preventDefault(); });
      });
    }

    /* drop the leftover spacers that sat between the moved blocks */
    for (var j = kids.indexOf(bb) + 1; j < kids.length; j++) {
      if (kids[j].classList.contains('spacer-block') && kids[j].parentElement === col) {
        var prev = kids[j].previousElementSibling;
        if (prev !== bb) kids[j].classList.add('m-ptabs-hide');
      }
    }
  }

  /* ---------- Menu: account link at the bottom ---------- */
  function initMenuExtras() {
    var util = document.querySelector('.menu-drawer .menu-drawer__utility-links');
    if (!util || util.querySelector('.m-menu-link')) return;
    var a = document.createElement('a');
    a.className = 'm-menu-link';
    a.href = '/account';
    a.textContent = 'Account';
    util.insertBefore(a, util.firstChild);
  }

  /* ---------- Cart drawer: brand line + "Size: L" (re-applied after every cart update) ---------- */
  var vendors = {};
  var loadingCart = false;
  function loadVendors(cb) {
    if (loadingCart) return;
    loadingCart = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        (c.items || []).forEach(function (it) { vendors[it.key] = it.vendor || ''; });
        loadingCart = false;
        cb();
      })
      .catch(function () { loadingCart = false; });
  }

  function enhanceCart(afterFetch) {
    var rows = document.querySelectorAll('.cart-drawer tbody .cart-items__table-row[data-key]');
    var missing = false;
    rows.forEach(function (row) {
      row.querySelectorAll('.cart-items__variant').forEach(function (v) {
        var dt = v.querySelector('dt'), dd = v.querySelector('dd');
        if (!dt || !dd) return;
        var name = dt.textContent.trim().replace(/:$/, '');
        if (/^type$/i.test(name)) { v.classList.add('m-ci-hide'); return; }
        if (!dt.classList.contains('m-ci-dt')) {
          dt.classList.remove('visually-hidden');
          dt.classList.add('m-ci-dt');
        }
        var clean = dd.textContent.replace(/[,\s ]+$/, '');
        if (dd.textContent !== clean) dd.textContent = clean;
      });
      var p = row.querySelector('.cart-items__details > p');
      if (!p || p.querySelector('.m-ci-brand')) return;
      var key = row.getAttribute('data-key');
      if (!(key in vendors)) {
        if (afterFetch === true) { vendors[key] = ''; return; }
        missing = true;
        return;
      }
      if (!vendors[key]) return;
      var s = document.createElement('span');
      s.className = 'm-ci-brand';
      s.textContent = vendors[key];
      p.insertBefore(s, p.firstChild);
    });
    if (missing) loadVendors(function () { enhanceCart(true); });
  }

  function initCart() {
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; try { enhanceCart(false); } catch (e) {} });
    }).observe(document.body, { childList: true, subtree: true });
    enhanceCart(false);
  }

  /* ---------- Footer: menus always open on phones (laid out in two columns by CSS) ---------- */
  function initFooter() {
    if (!mq.matches) return;
    document.querySelectorAll('.shopify-section-group-footer-group details.menu__details').forEach(function (d) {
      d.open = true;
      var s = d.querySelector('summary');
      if (s) s.addEventListener('click', function (e) { e.preventDefault(); });
    });
  }

  /* ---------- Filters (drawer + desktop sidebar): sections closed by default, brand search ---------- */
  function initFilters() {
    if (!document.querySelector('.facets__form, #filters-drawer')) return;
    var userOpen = {};
    var query = '';
    function key(d) {
      var l = d.querySelector('.facets__summary .facets__label');
      return (d.closest('#filters-drawer') ? 'd:' : 's:') + (l ? l.textContent.trim() : '');
    }
    function panels() { return document.querySelectorAll('details.facets__panel[id^="Facet-Details"]'); }
    function filterBrands(wrap) {
      var q = query.trim().toLowerCase();
      var panel = wrap.closest('.facets__inputs') || wrap.parentElement;
      panel.classList.toggle('m-bs-on', !!q);
      panel.querySelectorAll('.facets__inputs-list-item').forEach(function (li) {
        var miss = !!q && li.textContent.trim().toLowerCase().indexOf(q) === -1;
        li.classList.toggle('m-bs-miss', miss);
      });
      var empty = wrap.querySelector('.m-bs-empty');
      var any = panel.querySelector('.facets__inputs-list-item:not(.m-bs-miss)');
      if (empty) empty.hidden = !(q && !any);
    }
    function addSearch(d) {
      var box = d.querySelector('.facets__inputs');
      var comp = box && box.querySelector('facet-inputs-component');
      if (!comp) return;
      var wrap = box.querySelector('.m-bs');
      if (!wrap) {
        wrap = document.createElement('div');
        wrap.className = 'm-bs';
        wrap.innerHTML = '<div class="m-bs-field"><input type="search" class="m-bs-input" placeholder="SEARCH" aria-label="Search brand" autocomplete="off" autocorrect="off" spellcheck="false"><span class="m-bs-icon" aria-hidden="true"></span></div><p class="m-bs-empty" hidden>No brands found</p>';
        box.insertBefore(wrap, comp);
        var input = wrap.querySelector('input');
        ['input', 'change', 'keyup'].forEach(function (t) {
          input.addEventListener(t, function (e) {
            e.stopPropagation();
            if (t !== 'change') { query = input.value; filterBrands(wrap); }
          });
        });
        input.addEventListener('keydown', function (e) {
          e.stopPropagation();
          if (e.key === 'Enter') e.preventDefault();
        });
      }
      var inp = wrap.querySelector('input');
      if (inp.value !== query && document.activeElement !== inp) inp.value = query;
      filterBrands(wrap);
    }
    function apply() {
      panels().forEach(function (d) {
        /* desktop sidebar: Categories + Designers always open (plain lists) */
        var force = !mq.matches && !d.closest('#filters-drawer') && /product_type|vendor/.test(d.id);
        var want = force || !!userOpen[key(d)];
        if (d.open !== want) d.open = want;
        if (/vendor/.test(d.id)) addSearch(d);
      });
    }
    document.addEventListener('click', function (e) {
      var s = e.target.closest && e.target.closest('details.facets__panel[id^="Facet-Details"] > summary');
      if (!s) return;
      var d = s.parentElement;
      userOpen[key(d)] = !d.open;
    }, true);
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; try { apply(); } catch (e) {} });
    }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['open'] });
    apply();
  }

  function init() {
    try { initFilters(); } catch (e) {}
    try { initCart(); } catch (e) {}
    try { initFooter(); } catch (e) {}
    try { initStickyATC(); } catch (e) {}
    try { initProductInfo(); } catch (e) {}
    try { initMenuExtras(); } catch (e) {}
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.header__icon--menu')) {
        setTimeout(function () { try { initMenuExtras(); } catch (err) {} }, 50);
      }
    });
    try { initAZ(); } catch (e) {}
    try { initSwipe(); } catch (e) {}
    try { initStoreIntro(); } catch (e) {}
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
